import { callbacks, setCallback } from './callbacks';
import { app } from './appEnvironment';
import utils from '../scripts/utils';

const askMeStartAuth = (callback) => {
    setCallback("afterAuth", callback);
    app.callFunction("askMeStartAuth");
}

const willStartAuth = (data) => {
    data = utils.saveAuthorizationToken(utils.fromStringToJson(data));
    callbacks.afterAuth(data);
}

const initAuth = () => {
    window.willStartAuth = willStartAuth;
    window.onTokenRefreshed = onTokenRefreshed;
}

const startRefreshToken = () => {
    app.callFunction("startRefreshToken");
}

const onTokenRefreshed = (data) => {
    utils.saveAuthorizationToken(utils.fromStringToJson(data));
}

export { askMeStartAuth, initAuth, startRefreshToken };